import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Finanzen",
  "lead": "Eines von drei Ländern hat keines der im Aktionsrahmen Bildung 2030 festgelegten finanziellen Benchmarks erreicht."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, HighlightByPalette, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!HighlightByPalette) _missingMdxReference("HighlightByPalette", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_FINANCE"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Die ehrgeizigen SDG-Bildungsunterziele können ohne zusätzliche Ressourcen nicht erreicht werden, insbesondere nicht in den Ländern, die am weitesten zurückliegen."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Im GEM-Bericht wird geschätzt, dass die Länder mit niedrigem und mittlerem Einkommen jährlich 461 Mrd. USD aufwenden müssen, um das Ziel einer universellen Grundbildung – einschließlich Vorschul-, Grund- und Sekundarschulbildung – bis 2030 zu erreichen. In vielen Ländern ist es aufgrund niedriger Steuereinnahmen unwahrscheinlich, dass die Budgets ausreichend erhöht werden können, was zu einer geschätzten jährlichen Finanzierungslücke von 97 Mrd. USD führt. Diese Lücke entspricht 21 % der Gesamtkosten, die notwendig sind, um die nationalen Bildungsziele zwischen 2023 und 2030 zu erreichen. Die durchschnittliche Finanzierungslücke beträgt 26 Mrd. USD (50 % des Gesamtbetrags) in Ländern mit niedrigem Einkommen und 71 Mrd. USD (17 %) in Ländern mit niedrigem mittlerem Einkommen. Dies entspricht 2,3 % des BIP dieser Länder im Zeitraum bis 2030."
    }), "\n", _jsx(IndicatorReference, {
      id: "4.5.3",
      children: _jsxs(_components.p, {
        children: ["Mehr Mittel allein sind jedoch nicht ausreichend. Länder, die den gleichen Betrag an Pro-Kopf-Einkommen ausgeben, können sehr unterschiedliche Bildungsergebnisse erzielen, je nachdem, wie effektiv, effizient und gerecht sie investieren. Von 78 Ländern mit niedrigem und mittlerem Einkommen, zu denen Informationen vorliegen, haben beispielsweise nur 17 - oder eines von fünf Ländern - einen starken ", _jsx(_components.a, {
          href: "https://www.unesco.org/gem-report/en/node/80",
          children: "Gleichstellungsschwerpunkt in der Finanzierungspolitik"
        }), ". Dabei handelte es sich meist um Länder mit mittlerem Einkommen sowie Lateinamerika."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Die drei wichtigsten Quellen für Bildungsausgaben sind Regierungen, Haushalte und Geber. Auf dieser Seite werden die ersten beiden behandelt. Eine eigene Seite ist dem Thema ", _jsx(_components.a, {
        href: "https://www.education-progress.org/en/articles/finance-aid",
        children: "aid to education"
      }), " gewidmet."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TOTBYSOURCE"
        })
      }), _jsx(ScrollySection, {
        id: "absolute,0",
        children: _jsx(_components.p, {
          children: "Im Jahr 2022 wurden von den weltweit ausgegebenen 5,8 Billionen USD für Bildung lediglich 0,45 % in Ländern mit niedrigem Einkommen investiert, während 64 % in Ländern mit hohem Einkommen flossen, obwohl beide Gruppen ungefähr die gleiche Anzahl von schulpflichtigen Kindern haben."
        })
      }), _jsx(ScrollySection, {
        id: "relative,1",
        children: _jsxs(_components.p, {
          children: ["In Ländern mit mittlerem Einkommen, ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "1",
            children: "tragen Haushalte"
          }), " ein Viertel der Kosten für die Bildung bei. Tatsächlich tragen Haushalte in Ländern mit niedrigem und niedrigem bis mittlerem Einkommen mit 44 % einen wesentlich höheren Anteil an den Bildungsaufwendungen als in Ländern mit hohem Einkommen, wo dieser Anteil nur bei 20 % liegt."]
        })
      }), _jsx(ScrollySection, {
        id: "relative,2",
        children: _jsxs(_components.p, {
          children: ["Obwohl ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "Geber"
          }), " 12 % zu den gesamten Bildungsausgaben in Ländern mit niedrigem Einkommen beitragen ..."]
        })
      }), _jsx(ScrollySection, {
        id: "absolute,3",
        children: _jsxs(_components.p, {
          children: [".. ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "machen die"
          }), " Beiträge der Geber nur 0,3 % der Gesamtausgaben weltweit aus, was in absoluten Beträgen kaum sichtbar ist."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "öffentliche-ausgaben",
      children: "Öffentliche Ausgaben"
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.1",
      children: [_jsxs(_components.p, {
        children: ["Der ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
          children: "Aktionsrahmen Bildung 2030"
        }), " hat den Regierungen zwei wichtige finanzielle Benchmarks vorgegeben. Sie wurden aufgefordert"]
      }), _jsx(_components.p, {
        children: "mindestens 4 bis 6 % des BIP für die Bildung aufzuwenden und/oder\nmindestens 15 bis 20 % der öffentlichen Ausgaben für die Bildung aufzuwenden."
      }), _jsx(_components.p, {
        children: "Weltweit sind die Regierungen nicht weit von diesen Vorgaben abgewichen. Der Median der Staatsausgaben beträgt 4 % des BIP und 12,6 % der gesamten öffentlichen Ausgaben. Regierungen in ärmeren Ländern, die über eine geringe Fähigkeit zur Erwirtschaftung inländischer Ressourcen verfügen, aber große Kinderjahrgänge haben, investieren tendenziell weniger in Bildung als Prozentsatz des BIP, jedoch mehr im Verhältnis zu ihren gesamten Staatsausgaben."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.2",
      children: [_jsx(_components.p, {
        children: "In den afrikanischen Ländern südlich der Sahara entfallen 15,5 % der gesamten öffentlichen Ausgaben auf den Bildungsbereich, was jedoch nur 3,5 % des BIP ausmacht. Im Gegensatz dazu erfüllt Europa und Nordamerika die Benchmark in Bezug auf den Anteil am BIP (4,8 %), verwendet jedoch einen geringeren Anteil der Gesamtausgaben für Bildung (10,9 %)."
      }), _jsx(_components.p, {
        children: "Insgesamt erfüllte jedoch etwa jedes dritte Land, für das aktuelle Daten vorliegen, keinen der beiden Benchmarks. Spielen Sie diese Daten im Laufe der Zeit ab, um zu sehen, wie sich die Ausgaben im Laufe der Jahre verändern."
      })]
    }), "\n", _jsx(Figure, {
      id: "GOVVGDP"
    }), "\n", _jsx(_components.p, {
      children: "Die Haupteinnahmequelle des Staates ist die Besteuerung, selbst in Ländern mit niedrigem Einkommen, die einen großen Teil ihrer Einkünfte aus Zuschüssen (d. h. aus Beihilfen) beziehen. Das durchschnittliche Steueraufkommen im Verhältnis zum BIP betrug insgesamt 14 % in Ländern mit niedrigem Einkommen, 18 % in Ländern mit niedrigem bis mittlerem Einkommen, 22 % in Ländern mit mittelhohem Einkommen und 33 % in Ländern mit hohem Einkommen. Selbst wenn alle Länder der Bildung die gleiche Priorität einräumen würden, würden beispielsweise Länder, die höhere Steuereinnahmen und andere inländische Mittel generieren, mehr für Bildung ausgeben können."
    }), "\n", _jsx(_components.p, {
      children: "Die großen Unterschiede bei den Bildungsausgaben zwischen Ländern mit ansonsten ähnlichen Merkmalen zeigen jedoch, dass diese Beziehungen nicht zwangsläufig festgelegt sind. Einige Länder entscheiden sich dafür, mehr für Bildung auszugeben, um ihre Ziele zu erreichen. Und wir sollten die hervorheben, die das nicht tun."
    }), "\n", _jsx(_components.h2, {
      id: "haushaltsausgaben",
      children: "Haushaltsausgaben"
    }), "\n", _jsx(_components.p, {
      children: "In ärmeren Ländern geben Haushalte einen erheblichen Betrag für die Bildung ihrer Kinder aus, oft sogar mehr als in wohlhabenderen Ländern."
    }), "\n", _jsx(_components.p, {
      children: "Diese Ausgaben können sowohl in Form von Schulgeld und anderen Gebühren anfallen als auch für Bildungsgüter und -dienstleistungen, die teils obligatorisch sind (wie Schulbücher), aber auch freiwillige Kosten wie Nachhilfe umfassen können."
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.4",
      children: [_jsx(_components.p, {
        children: "Wenn solche Daten länderübergreifend standardisiert werden, liefern sie beeindruckende Einblicke in den Beitrag der Haushalte zu den gesamten Bildungsausgaben. Dies kann die Perspektive auf die Anstrengungen der Länder im Bildungsbereich erheblich verändern und ein besseres Verständnis für die unterschiedlichen Herausforderungen und Prioritäten schaffen."
      }), _jsx(_components.p, {
        children: "In Ländern mit niedrigem Einkommen geben die Haushalte aufgrund wirtschaftlicher Not oft weniger als 1 % ihres Budgets für Bildung aus, da sie ihre Ressourcen auf dringendere Bedürfnisse konzentrieren müssen. Im Gegensatz dazu geben Haushalte in Ländern mit niedrigem bis mittlerem Einkommen im Median 2,9 % und im ungewichteten Mittel 3,6 % ihrer Ausgaben für Bildung aus. Die Verteilung dieser Ausgaben variiert dabei stärker als in anderen Einkommensgruppen. Das hohe Ausgabenniveau in Ländern mit niedrigem bis mittlerem Einkommen deutet darauf hin, dass die Haushalte unter Druck stehen, die unzureichenden öffentlichen Mittel zu ergänzen. In den Ländern mit mittlerem und höherem Einkommen sinkt der mittlere Anteil der Haushaltsausgaben für Bildung auf 1,5 %, bei einem ungewichteten Mittelwert von 2,3 %. Haushalte in Ländern mit hohem Einkommen geben im Median 1,3 % und im ungewichteten Mittel 1,7 % ihrer Ausgaben für Bildung aus."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GOVHH_ABS_REL"
          })
        }), _jsx(ScrollySection, {
          id: "absolute,BGD,FRA",
          children: _jsxs(_components.p, {
            children: ["Zum Beispiel hatte ", _jsx(_components.strong, {
              children: "Bangladesch"
            }), " im Jahr 2019 eines der niedrigsten Niveaus an ", _jsx(HighlightByIndex, {
              index: "0",
              children: "staatlichen Ausgaben,"
            }), " ausgedrückt als Prozentsatz des BIP. Dennoch, sobald man ", _jsx(HighlightByIndex, {
              index: "1",
              children: "die Haushaltsbeiträge"
            }), " berücksichtigt, dann die nationalen Gesamtausgaben für Bildung in Bangladesch in Prozent des BIP ähnlich hoch wie in ", _jsx(_components.strong, {
              children: "Frankreich"
            }), "."]
          })
        }), _jsx(ScrollySection, {
          id: "absolute,IND,BEL",
          children: _jsxs(_components.p, {
            children: ["Die Regierung von ", _jsx(_components.strong, {
              children: "Indien"
            }), " gab etwa 2,4 ", _jsx(HighlightByIndex, {
              index: "0",
              children: "Prozentpunkte des BIP"
            }), " weniger für Bildung aus als ", _jsx(_components.strong, {
              children: "Belgien"
            }), " – der blaue Balken –, jedoch gab Indien  insgesamt mehr als Belgien aus, da die", _jsx(HighlightByIndex, {
              index: "1",
              children: "Haushaltsausgaben"
            }), " mehr als 2,6 Prozentpunkte des BIP für Bildung ausmachen (der rote Balken)."]
          })
        }), _jsx(ScrollySection, {
          id: "relative,NGA,LBN,HTI",
          children: _jsxs(_components.p, {
            children: ["Der ", _jsx(HighlightByIndex, {
              index: "1",
              children: "Anteil der Haushaltsausgaben"
            }), " an den gesamten Bildungsausgaben steigt in einigen Ländern auf über 70 %, darunter ", _jsx(_components.strong, {
              children: "Nigeria"
            }), ", ", _jsx(_components.strong, {
              children: "Haiti"
            }), " und ", _jsx(_components.strong, {
              children: "Libanon"
            }), "."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "schlussfolgerung",
      children: "Schlussfolgerung"
    }), "\n", _jsx(_components.p, {
      children: "Das Team des Global Education Monitoring Report betont seit langem, dass zur vollständigen Analyse der globalen Bildungsausgaben eine integrierte Betrachtung der drei Hauptquellen der Bildungsfinanzierung notwendig ist: inländische öffentliche Mittel, externe öffentliche Mittel und private Mittel. Es besteht daher ein dringender Bedarf an aktuellen und konsistenten Daten aus Ländern mit niedrigem und mittlerem Einkommen, um zu ermitteln, wie viel für Bildung ausgegeben wird und aus welchen Quellen diese Mittel stammen."
    }), "\n", _jsx(_components.p, {
      children: "Neben der Aufstockung der für die Bildung zur Verfügung stehenden Mittel muss auch die Verteilungsgerechtigkeit verbessert werden. Um das globale Bildungsziel, SDG 4, zu erreichen, ist es wichtig, dass Länder und Geber Verantwortung übernehmen und ihre Verpflichtungen erfüllen."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024efw",
            children: "Education Finance Watch 2024"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/financing-for-equity",
            children: "Unlocking Financing for Equity in Education"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://education-profiles.org/",
            children: "Profiles Enhancing Education Reviews (PEER)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/node/3141",
            children: "COVID-19 is a Serious Threat to Aid to Education Recovery"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
